<template>
  <div class="login-wrapper">
    <a href="https://www.complyon.com/" class="mt-3 ml-3 white-logo">
      <img src="@/assets/complyon-white.png" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <a href="https://www.complyon.com/" class="mt-3 ml-3 black-logo">
      <img src="@/assets/complyon_logo.svg" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <span class="login-credits">
      Photo by
      <a href="https://www.tiredofbeingmild.com/">@tiredofbeingmild</a>
    </span>
    <div class="register-form">
      <!-- <div class="col-sm-12 col-md-6">
        <div class="login-carousel">
          <Carousel :autoplay="true" :perPage="1" :loop="true" :autoplayTimeout="5000">
            <Slide>
              <img src="@/assets/login-image-1.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-2.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-3.jpg" style="width: auto; height: 100vh">
            </Slide>
            <Slide>
              <img src="@/assets/login-image-4.jpg" style="width: auto; height: 100vh">
            </Slide>
          </Carousel>
        </div>
      </div>
      <div class="col-sm-12 col-md-6"> -->
      <!-- <div class="pl-5 mt-3 mb-3">
        <a href="https://complyon.com">
          <img src="@/assets/complyon_logo.svg" alt="">
        </a>
      </div> -->
      <div class="register pl-4 pr-4 pt-3">

        <h3 class="text-bold mb-2">
          {{ $t('register.title') }}
        </h3>
        <div v-if="!registerLoading" class="mb-3">
          {{ $t('register.login_link_label') }}
          <span class="text-success cursor-pointer" @click="goToLogin()">
              {{ $t('register.login_link') }}
            </span>
        </div>

        <div class="text-center" v-if="registerLoading">
          <div class="mt-5 mb-3" style="height: 30px;">
            <div class="swing-container">
              <div class="swing">
                <div class="swing-l"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="swing-r"></div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <h5>{{ registerLoadingMessage }}</h5>
          </div>

        </div>

        <div v-if="!showForgotPassword && !registerLoading">

          <b-form @submit="onSubmit" qid="login-form">
            <div class="form-container">

              <div class="mt-3">
                <b-alert v-if="error"
                         show
                         variant="danger"
                         qid="register-form-error"
                >
                  {{ error }}
                </b-alert>
              </div>

              <b-form-group>
                <label>
                  {{ $t('register.company_name_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-input
                        qid="input-register-company"
                        type="text"
                        v-model="form.company_name"
                        required
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <label>
                  {{ $t('register.full_name_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-input
                        qid="input-register-name"
                        type="text"
                        v-model="form.name"
                        required
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <label>
                  {{ $t('register.email_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-input
                        qid="input-login-email"
                        type="email"
                        v-model="form.email"
                        required
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <div class="row">
                  <div class="col-sm-6">
                    <label qid="password">
                      {{ $t('register.password_label') }}
                      <span class="text-red">*</span>
                    </label>
                    <b-form-input
                            type="password"
                            qid="input-reset-password"
                            v-model="form.password"
                            required
                            :state="validationPass"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validationPass">
                      {{ $t('reset_password.notice.password_requirement') }}
                    </b-form-invalid-feedback>
                  </div>
                  <div class="col-sm-6">
                    <label qid="confirm-password">
                      {{ $t('register.confirm_password_label') }}
                      <span class="text-red">*</span>
                    </label>
                    <b-form-input
                            type="password"
                            qid="input-reset-password_confirmation"
                            v-model="form.password_confirmation"
                            required
                            :state="validationRepeatPass"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validationRepeatPass">
                      {{ $t('reset_password.notice.do_not_match') }}
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback
                            :state="validationRepeatPass"
                            v-if="form.password_confirmation && form.password_confirmation.length"
                    >
                      {{ $t('reset_password.notice.looks_good') }}
                    </b-form-valid-feedback>
                  </div>
                </div>
              </b-form-group>

              <p>
                <small>
                  {{ $t('register.first_description_text') }}
                </small>
              </p>

              <b-form-group>
                <b-form-checkbox
                        v-model="form.terms"
                        name="checkbox-terms"
                        :value="1"
                        class="float-left"
                        :unchecked-value="0"
                >
                  {{ $t('register.i_agree') }}
                  <a href="https://complyon.com/terms-of-use/" target="_blank">
                    {{ $t('register.terms_of_use') }}
                  </a>
                  {{ $t('system.and') }}
                  <a href="https://complyon.com/privacy-policy/" target="_blank">
                    {{ $t('register.privacy_policy') }}
                  </a>
                  <span class="text-red">*</span>
                </b-form-checkbox>
                <div class="text-muted cursor-pointer float-left pl-1 pt-1" v-if="!showPolicyText" @click="showPolicyText=!showPolicyText">
                  ({{ $t('system.read_more') }})
                </div>
                <div class="text-muted cursor-pointer float-left pl-1 pt-1" v-if="showPolicyText" @click="showPolicyText=!showPolicyText">
                  ({{ $t('system.read_less') }})
                </div>
              </b-form-group>

              <p v-if="showPolicyText">
                <small>
                  {{ $t('register.second_description_text') }}
                </small>
              </p>

              <p v-if="showPolicyText">
                <small>
                  {{ $t('register.third_description_text') }}
                </small>
              </p>

              <b-form-checkbox
                      v-model="form.newsletter"
                      name="checkbox-newsletter"
                      :value="1"
                      :unchecked-value="0"
              >
                {{ $t('register.newsletter') }}
              </b-form-checkbox>

              <br>

              <!-- Google recaptcha container -->
              <div id="robot"></div>

            </div>

            <div class="text-center mt-3">
              <b-button type="submit"
                        variant="success"
                        :disabled="buttonDisabled"
                        class="pb-2 pt-2 pl-5 pr-5"
                        qid="button-submit-register"
              >
                {{ $t('register.submit_button') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import roleCheck from '@/util/ACL/roleCheck.js'
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    components: {
      Carousel,
      Slide
    },
    data: function() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          company_name: '',
          size: '',
          country: '',
          wrongCredentials: false,
          password: '',
          password_confirmation: '',
          terms: '',
          privacy: '',
          newsletter: '',
          errorMessage: ''
        },
        companySizeItems: [
          { name: '0 - 25', value: '0 - 25' },
          { name: '26 - 200', value: '26 - 200' },
          { name: '201 - 500', value: '201 - 500' },
          { name: '501 - 2,000', value: '501 - 2,000' },
          { name: '2,001 - 10,000', value: '2,001 - 10,000' },
          { name: '10,000+', value: '10,000+' }
        ],
        selectedSize: [],
        countries: [],
        selectedCountry: [],
        forgotPassForm: {
          email: '',
          errorMessage: ''
        },
        showForgotPassword: false,
        error: '',
        buttonDisabled: false,
        registerLoading: false,
        registerLoadingMessage: '',
        showPolicyText: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getHistoryPage() {
        return this.$store.state.historyPage
      },
      validationPass() {
        let containsCapital = RegExp('[A-Z]');
        let containsSpecial = RegExp('\\W');

        return this.form.password && this.form.password.length > 7 && containsCapital.test(this.form.password) && containsSpecial.test(this.form.password);
      },
      validationRepeatPass() {
        return this.form.password_confirmation && this.form.password === this.form.password_confirmation;
      }
    },
    methods: {

      redirectOnHome(user) {
        if (user.isAdmin) {
          window.location.href = '/administration';
        } else {
          window.location.href = '/';
        }
      },
      setLoadingMessage() {
        let self = this;
        this.registerLoadingMessage = ''

        this.registerLoadingMessage = this.$t('system.register_loading_message_1')

        setTimeout(function(){
          self.registerLoadingMessage = self.$t('system.register_loading_message_2')
        }, 3000);

        setTimeout(function(){
          self.registerLoadingMessage = self.$t('system.register_loading_message_3')
        }, 6000);
      },
      goToLogin() {
        this.$router.push({name: 'login', params: {}})
      },
      loadCountries() {
        let self = this;
        piincHttp.get('countries-with-flag').then(function(response) {
          self.countries = response.data
        }, function() {});
      },
      populatePhone(object) {
        if ((!this.form.phone.length) || (this.form.phone.startsWith('+')) && this.form.phone.length <= 4) {
          this.form.phone = '+' + object.calling_code
        }
      },
      removePhone(object) {
        if ((!this.form.phone.length) || (this.form.phone.startsWith('+')) && this.form.phone.length <= 4) {
          this.form.phone = ''
        }
      },
      onSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        let self = this;
        evt.preventDefault();

        this.$gtag.event('sign_up', {
          'event_category': 'engagement',
          'event_label': 'method'
        })

        if (typeof window.lintrk === 'function') {
          window.lintrk('track', { conversion_id: 6255234 });
        }

        // this.form.size = '';
        // if (this.selectedSize && this.selectedSize.value) {
        //   this.form.size = this.selectedSize.value
        // }

        // this.form.country = '';
        // if (this.selectedCountry && this.selectedCountry.name) {
        //   this.form.country = this.selectedCountry.name
        // }

        // Uncomment this line and comment the one below to enable recaptcha validation
        if (this.form.terms && grecaptcha.getResponse().length) {
          // if (this.form.terms) {
          this.registerLoading = true;
          this.setLoadingMessage()
          piincHttp.post('register', this.form).then(function(response) {
            self.buttonDisabled = false;
            self.$router.push({name: 'login', params: {success: true}})
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.registerLoading = false;
              self.form.wrongCredentials = true;
              self.error = error.data.message;
              if (error.status === 429 || error.status === 422) {
                // TODO: This needs to cover all errors from the array
                self.error = error.data.errors.email[0];
              }
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = '';
          // if (!this.selectedCountry || (this.selectedCountry && !this.selectedCountry.name)) {
          //   this.error +=  ' ' + this.$t('system.country_error_message')
          // }
          // if (!this.selectedSize || (this.selectedSize && !this.selectedSize.value)) {
          //   this.error +=  ' ' + this.$t('system.company_size_error_message')
          // }
          if (!this.form.terms) {
            this.error +=  ' ' + this.$t('system.terms_error_message')
          }
          if (!grecaptcha.getResponse().length) {
            this.error +=  ' ' + this.$t('system.recaptcha_error_message')
          }
        }
      }
    },
    // Lifecycle hooks
    created() {
      let self = this;

      this.$gtag.pageview('/register')

      // Load recaptcha after load of the page
      setTimeout(function(){
        grecaptcha.render('robot', {
          'sitekey' : '6Ld2RbIbAAAAAAazfFZyE98UYP88B5WbKz4F2eT0'
        });
      }, 500);

      this.loadCountries()
    }
  }
</script>
